import { render, staticRenderFns } from "./ActivateDeactivateDSR.vue?vue&type=template&id=10d911e9&"
import script from "./ActivateDeactivateDSR.vue?vue&type=script&lang=js&"
export * from "./ActivateDeactivateDSR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports